
import SocialButton from "./base/SocialButton.jsx";
import React from "react";
import {useNavigate} from "react-router-dom";
import { theme } from "../theme.js";

const API_URL = process.env.REACT_APP_API_URL;

export default function ConnexionCard({children, brand, title, subtitle, socials = true}) {

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [formData, setFormData] = React.useState({});
  let user, participant;

  const navigate = useNavigate();

  const loginWithGoogle = (e) => {
    e.preventDefault();
    // Rediriger directement vers l'endpoint OAuth de Google
    window.location.href = `${API_URL}/auth/google`;
  };

  const loginWithApple = () => {
    window.location.href = `https://appleid.apple.com/auth/authorize?response_type=code&response_mode=form_post&client_id=YOUR_CLIENT_ID&redirect_uri=${API_URL}/auth/apple/callback&scope=name%20email`;
  };


  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.brand}>{brand}</div>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.subtitle}>{subtitle}</p>

        {socials && (
        <>
          <div style={styles.socials}>
            <SocialButton provider="google" onClick={loginWithGoogle} />
            {/*<SocialButton provider="apple" onClick={loginWithApple} />*/}
          </div>
          <div style={styles.divider}><span>or</span></div>
        </>
        )}

        {children}

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #111 0%, #222 100%)",
    padding: theme.spacing.lg,
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: theme.colors.white,
    borderRadius: theme.radius.xl,
    boxShadow: theme.shadows.xl,
    padding: theme.spacing.lg,
  },
  brand: {
    fontWeight: theme.fonts.weight.extrabold,
    letterSpacing: 0.5,
    color: theme.colors.text,
    fontSize: theme.fonts.size.sm,
    marginBottom: theme.spacing.xs,
  },
  title: {
    fontSize: theme.fonts.size.xl,
    margin: 0,
    color: theme.colors.textInverted,
  },
  subtitle: {
    margin: `${theme.spacing.xs} 0 ${theme.spacing.md} 0`,
    color: theme.colors.textInverted,
    fontSize: theme.fonts.size.sm,
  },
  socials: {
    display: "grid",
    gap: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
  divider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: `${theme.spacing.xs} 0 ${theme.spacing.md} 0`,
    color: theme.colors.textInverted,
    fontSize: theme.fonts.size.xs,
  },
};
